import { timelineEvents } from "@/mocks/home";

function Timeline() {
  return (
    <section id="timeline" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-20">
        <div className="mb-10 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 font-label text-xs uppercase tracking-[0.24em] text-primary-600">
              Public Pulse
            </p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              身份追问的舆情脉络
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            从“内容热”到“问身份”，这条线索是怎么一步步被推上讨论台面的？按时间切几个关键节点。
          </p>
        </div>

        <ol className="relative border-l border-background-300 pl-8">
          {timelineEvents.map((e, i) => {
            const isLast = i === timelineEvents.length - 1;
            const markerTone =
              i === 0
                ? "bg-primary-500"
                : i === timelineEvents.length - 1
                  ? "bg-foreground-950"
                  : "bg-accent-500";
            return (
              <li key={e.id} className={"relative " + (isLast ? "" : "pb-10")}>
                <span
                  className={
                    "absolute -left-[41px] top-1.5 flex h-5 w-5 items-center justify-center rounded-full ring-4 ring-background-50 " +
                    markerTone
                  }
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-background-50"></span>
                </span>
                <span className="inline-flex items-center rounded-full bg-secondary-100 px-3 py-1 font-label text-xs font-semibold tracking-wide text-secondary-900">
                  {e.time}
                </span>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">{e.title}</h3>
                <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-foreground-600">{e.desc}</p>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}

export default Timeline;